<template >
  <div class="chart-wrapper">
    <MainChartTabs @tabMutated="tabMutated" />
    <MainChartTips class="top-title" v-show="showTip && titleData.length" :titleData="titleData" :isLikeMin1="isLikeMin1" />
    <div class="chart-section">
      <div class="left" :class="{ 'left-full': !showRight }">
        <img class="icon"
          src="data:image/png;base64,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"
          alt="">
        <MainChartSubTips v-show="!isLikeMin1" :show="showTip" class="sub-title" :tick="subTitleData" />
        <div class="main-chart-top" @touchstart="touchStart($event, 'topChart')"
          @touchmove="touchMove($event, 'topChart')" @touchend="touchEnd($event, 'topChart')"
          :class="{ 'top-full': !isLikeMin1 }" id="main-chart-top">
        </div>
        <MainChartIndicators class="indicators" v-show="!isLikeMin1" @indicatorMutated="indicatorMutated" />
        <MainChartSubTips :show="showTip" tipType="bottom" class="sub-title bottom-title" :tick="bottomTitleData" />
        <div class="main-chart-bottom" @touchstart="touchStart($event, 'bottomChart')"
          @touchmove="touchMove($event, 'bottomChart')" @touchend="touchEnd($event, 'bottomChart')"
          :class="{ 'bottom-full': !isLikeMin1 }" id="main-chart-bottom">
        </div>
      </div>
      <div class="right" v-show="showRight">
        <ChartPanel />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import echarts from 'echarts'
import MainChartTabs from './MainChartTabs'
import MainChartTips from './MainChartTips'
import MainChartSubTips from './MainChartSubTips'
import MainChartIndicators from './MainChartIndicators'
import ChartPanel from './ChartPanel/index.vue'
import { getKlineByHttp } from '@/api'
import { ws } from '@/websocket'
const last = require('lodash/last')
const unitUtils = require('@/utils/formatUnit')
import charts from '@/utils/chart/index'
import config from '@/utils/chart/config'
import { isUsaSummer } from '@/utils/index'
export default {
  data() {
    return {
      MIN1Time: null,
      titleData: [
        // {title: '', value: '', className: ''}
      ],
      subTitleData: [
        // {title: 'MA5', value: 1.23, color: ''},
      ],
      bottomTitleData: [],
      showTip: false,
      tradingKlines: config.tradingKlines,
      klineType: 'MIN1',
      techType: 'v',
      init: false,
      dataSet: {},
      klineDataInit: false,
      // if realKlineType is not null, klineType convert to realKlineType after handle data
      realKlineType: null,
      klineStack: [],
      pendingType: {},
      topOptions: {
        grid: {
          top: 15,
          left: 0,
          bottom: 21,
          right: 0
        }
      }
    }
  },
  computed: {
    ...mapState(['code', 'market', 'statistic', 'dyna', 'profile', 'region', 'isIndex']),
    showRight() {
      return !this.isIndex && this.klineType === 'MIN1'
    },
    isLikeMin1() {
      return config.tradingKlines.includes(this.klineType)
    },
  },
  watch: {
    showTip(val) {
      if (!val) {
        document.querySelector('#app').removeEventListener('touchmove', this.forbiddenScroll, false)
        this.resetTitle()
        this.handleTip({ show: val })
      } else {
        document.querySelector('#app').addEventListener('touchmove', this.forbiddenScroll, false)
      }
    }
  },
  created() {
    this.initRegion()
  },

  deactivated() { // 缓存解除绑定
    this.handleKlineStack(0)
    this.handleWSListeners('removeListener')
    ws.websocket.removeListener('onKLINE', this.cbKline)
  },
  mounted() {
    this.stock = {
      code: this.code,
      market: this.market
    }
    this.handleWSListeners('on')
    this.initDataSet(this.klineType)
    this.initData()
    this.topChart = echarts.init(
      document.getElementById(`main-chart-top`)
    )
    this.bottomChart = echarts.init(
      document.getElementById(`main-chart-bottom`)
    )
  },
  beforeDestroy() {
    this.handleKlineStack(0)
    this.handleWSListeners('removeListener')
    ws.websocket.removeListener('onKLINE', this.cbKline)
  },
  components: {
    MainChartTabs,
    MainChartIndicators,
    MainChartTips,
    MainChartSubTips,
    ChartPanel
  },
  methods: {
    initRegion() {
      this.klines = config.klines(this.region)
      this.MIN1Time = charts.tradingTime.create(this.region)
      this.regionConfig = config.region[this.region]
    },
    initDataSet(key) {
      this.dataSet[key] = {
        t: [],
        h: [],
        o: [],
        l: [],
        c: [],
        v: [],
        a: [],
        avg: [],
        totalAmount: 0,
        totalVol: 0
      }
    },
    initData(st) {
      if (this.klineType === 'MIN1') {
        this.getKlineByWS()
      } else {
        this.getKlineByHttp(st)
      }
    },
    getKlineByWS() {
      this.klineStack.length > 1 && this.handleKlineStack(0)
      this.handleKlineStack(1)
    },
    // 1: into stack, 0: out of stack
    handleKlineStack(flag) {
      const { code, market } = this.stock
      let tmpMarket = 'DELAY_' + market
      if (flag) {
        this.klineStack.push(this.klineType)
        ws.websocket.safeSubscribeKLINE(code, tmpMarket, this.klineType)
      } else {
        let klineType = this.klineStack.pop()
        ws.websocket.safeUnsubscribeKLINE(code, tmpMarket, klineType)
      }
    },
    handleWSListeners(key) {
      ws.websocket[key]('onKLINE', this.cbKline)
    },
    async getKlineByHttp(st) {
      let oldKlineType = this.oldKlineType = this.klineType
      if (this.pendingType[oldKlineType]) return
      this.pendingType[oldKlineType] = true
      const myKline = this.klines[oldKlineType]
      const params = {
        endtime: parseInt(new Date().getTime() / 1000),
        inst: this.stock.code,
        limit: -myKline.limit,
        market: this.stock.market,
        servicetype: 'KLINEB',
        starttime: st ? st + 1 : 0,
        resptype: 'JSON',
        period: myKline.period || oldKlineType
      }
      const res = await getKlineByHttp(params)
      delete this.pendingType[oldKlineType]
      if (!res
        || !res.KlineData) {
        return
      }
      if (config.minKlines.includes(this.klineType) && oldKlineType === this.klineType) {
        this.getKlineByWS(res.Period)
      }
      this.handleData(res.KlineData, oldKlineType)
    },
    // 今天的
    cbKline(data) {
      let tmpMarket = data.Market.replace('DELAY_', '')
      if (data.Inst !== this.stock.code || tmpMarket.toLowerCase() !== this.stock.market.toLowerCase()) return
      if (data.length > 1 && this.klineDataInit) return
      this.handleData(data.QuoteData.KlineData, data.Period)
    },
    handleData(data, klineType) {
      let vm = this
      klineType = klineType || vm.klineType
      let limit = this.klines['MIN1'].limit
      let is5day = klineType === '5-MIN1' && data.length > limit
      let isMin1 = klineType === 'MIN1'
      let min1Len = this.dataSet['MIN1'].c.length
      let { h, o, l, c, t, v, a, avg, totalAmount, totalVol } = this.dataSet[klineType]
      if (last(t) === last(data).Time) {
        // 防止分钟k线重复
        if (!isMin1) return this.renderCandleChart()
        h.pop()
        o.pop()
        l.pop()
        c.pop()
        t.pop()
        avg.pop()
        totalVol = totalVol - v.pop()
        totalAmount = totalAmount - a.pop()
      }
      if (klineType === 'DAY' && data.length) {
        let today = charts.getTodayData(this.dataSet.MIN1, last(data))
        today && data.push(today)
      }
      data.forEach((el, index) => {
        if (is5day && index % limit === 0) {
          totalAmount = 0
          totalVol = 0
          t.push(el.Time + 1)
          h.push('-')
          o.push('-')
          l.push('-')
          c.push('-')
          v.push('-')
          a.push('-')
          avg.push('-')
        }
        totalAmount += el.Amount
        totalVol += el.Volume
        t.push(el.Time)
        h.push(el.High)
        o.push(el.Open)
        l.push(el.Low)
        c.push(el.Close)
        v.push(el.Volume)
        a.push(el.Amount)
        avg.push(charts.formatUnit(totalAmount / totalVol, 0, true, this.regionConfig.precision))
      })
      this.dataSet[klineType].totalAmount = totalAmount
      this.dataSet[klineType].totalVol = totalVol
      this.klineDataInit = true
      if (klineType === 'DAY' && this.realKlineType) {
        this.klineType = this.realKlineType
        this.realKlineType = null
      }
      if (vm.klineType === 'MIN1') return this.renderMIN1Chart()
      // 特殊的k线，可能需要借用MIN1作为今日数据
      if ((vm.klineType === '1-MIN1' || vm.klineType === '5-MIN1') && klineType !== 'MIN1') return this.borrowMIN1(klineType === 'MIN1', min1Len)
      if (klineType !== 'MIN1' && this.oldKlineType === this.klineType) return this.renderCandleChart()
    },
    borrowMIN1(isTick, len) {
      const vm = this
      let limit = this.klines['MIN1'].limit
      let dataSet = this.dataSet
      let debtor = dataSet[vm.klineType]
      let debtee = dataSet['MIN1']
      // 5日数据真空期
      if (!debtor.t.length && isTick) return
      const next = vm.klineType === '5-MIN1' ? this.renderMIN1Chart : this.renderCandleChart
      if (last(debtor.t) === last(debtee.t) || !debtee.c.length) return next()
      // 5日需要切除第一天数据
      if (!isTick && vm.klineType === '5-MIN1' && debtor.t.length > 4 * limit) {
        debtor.t.splice(0, limit)
        debtor.h.splice(0, limit)
        debtor.o.splice(0, limit)
        debtor.l.splice(0, limit)
        debtor.c.splice(0, limit)
        debtor.v.splice(0, limit)
        debtor.a.splice(0, limit)
        debtor.avg.splice(0, limit)
      }
      if (isTick) {
        debtor.t.splice(-len)
        debtor.h.splice(-len)
        debtor.o.splice(-len)
        debtor.l.splice(-len)
        debtor.c.splice(-len)
        debtor.v.splice(-len)
        debtor.a.splice(-len)
        debtor.avg.splice(-len)
      }
      dataSet[vm.klineType] = {
        t: debtor.t.concat(debtee.t),
        h: debtor.h.concat(debtee.h),
        o: debtor.o.concat(debtee.o),
        l: debtor.l.concat(debtee.l),
        c: debtor.c.concat(debtee.c),
        v: debtor.v.concat(debtee.v),
        a: debtor.a.concat(debtee.a),
        avg: debtor.avg.concat(debtee.avg),
        totalAmount: debtee.totalAmount,
        totalVol: debtee.totalVol
      }
        ; (this.klineType !== 'MIN1' || this.oldKlineType === this.klineType) && next()
    },
    renderMIN1Chart() {
      if (!this.isLikeMin1) return
      this.topChart.setOption(charts.MIN1Chart.options(this), true)
      this.renderBottomChart()
    },
    renderCandleChart() {
      if (this.isLikeMin1
        || charts.candle.options(this) === -1) return
      this.topChart.setOption(this.candleOption, true)
      this.renderBottomChart()
    },
    renderBottomChart() {
      charts.bottom.options(this)
      this.bottomChart.setOption(this.bottomOption, true)
      !this.init && this.decorateCharts()
    },
    resetTitle() {
      this.titleData = []
      this.subTitleData = []
      this.bottomTitleData = []
      this.topChart.dispatchAction({
        type: 'updateAxisPointer',
        currTrigger: 'leave'
      })
      this.bottomChart.dispatchAction({
        type: 'updateAxisPointer',
        currTrigger: 'leave'
      })
    },
    getTimeZone(t) {
      t = +t
      if (this.region === 'USA') {
        // 夏令时\冬令时
        t = isUsaSummer ? (t + 12 * 3600) : (t + 13 * 3600)
      }
      return t * 1000
    },
    createTitleData(index, val) {
      let { singleHand, precision } = this.regionConfig
      try {
        const { h, o, l, c, t, avg, v } = this.getMyData()
        let vol = unitUtils.formatUnit(v[index] / singleHand, false, true, 0)
        if (this.isLikeMin1) {
          let base = this.statistic.PreClosePrice
          let className = charts.getColorClass(c[index], base)
          this.titleData = [
            { title: '', value: charts.dateFormat(this.getTimeZone(t[index]), 'hh:mm') },
            { title: '价', value: c[index].toFixed(precision), className },
            { title: '幅', value: `${(((c[index] - base) / base) * 100).toFixed(2)}%`, className },
            { title: '量', value: vol },
          ]
          !this.isIndex
            && this.titleData.push(
              { title: '均', value: avg[index], className: charts.getColorClass(avg[index], base) }
            )
        } else {
          let base = c[index - 1] || c[index]
          this.titleData = [
            { title: '开', value: o[index].toFixed(precision), className: charts.getColorClass(o[index], base) },
            { title: '高', value: h[index].toFixed(precision), className: charts.getColorClass(h[index], base) },
            { title: '幅', value: `${(((c[index] - base) / base) * 100).toFixed(2)}%`, className: charts.getColorClass(c[index], base) },
            { title: '成交', value: vol },
            { title: '收', value: c[index].toFixed(precision), className: charts.getColorClass(c[index], base) },
            { title: '低', value: l[index].toFixed(precision), className: charts.getColorClass(l[index], base) },
            { title: '额', value: `${((c[index] - base)).toFixed(precision)}`, className: charts.getColorClass(c[index], base) },
          ]
          if (!this.isIndex) {
            let cgr
            if (this.region === 'CN') {
              cgr = (v[index] / this.profile.CircSkamt / 100).toFixed(2)
            } else {
              cgr = (v[index] / this.dyna.TotStock * 100).toFixed(2)
            }
            this.titleData.push(
              { title: '换手', value: isFinite(cgr) ? `${cgr}%` : '-' }
            )
          } else {
            let range = (((h[index] - l[index]) / base) * 100).toFixed(2)
            this.titleData.push(
              { title: '振幅', value: isFinite(range) ? `${range}%` : '-' }
            )
          }
        }
        !this.isLikeMin1 && this.createSubTitleData(val)
          ; (this.techType !== 'v' || this.techType !== 'BOLL')
            && this.createBottomTitle(index)
      } catch (e) { }
    },
    createSubTitleData(val) {
      this.subTitleData = charts.isDef(val)
        ? val.slice(1).map(item => {
          return {
            title: item.seriesName,
            color: item.color,
            className: 'rise-color',
            value: item.value ? item.value.toFixed(this.regionConfig.precision) : '-'
          }
        })
        : []
    },
    createBottomTitle(index) {
      this.bottomTitleData = charts.isDef(this.bottomRawData) && charts.isDef(index)
        ? this.bottomRawData.map(item => {
          return {
            title: item.name,
            value: unitUtils.formatUnit(item.data[index]),
            color: item.color
          }
        })
        : []
    },
    getMyData() {
      return this.dataSet[this.klineType]
    },
    decorateCharts() {
      this.init = true
      this.oldAxisLabelDistance = 0
      this.topChart.on('datazoom', obj => {
        if (this.isLikeMin1) return
        const { start, end } = obj.batch[0]
        let newAxisLabelDistance = end - start
        const myData = this.getMyData()
        if (this.oldAxisLabelDistance !== newAxisLabelDistance) {
          this.oldAxisLabelDistance = newAxisLabelDistance
          this.topChart.setOption({
            xAxis: {
              axisLabel: {
                interval: parseInt((newAxisLabelDistance) / 250 * myData.t.length)
              }
            }
          })
        }
        this.bottomChart.dispatchAction({
          type: 'dataZoom',
          batch: [{
            start,
            end
          }]
        })
      })
      charts.connectCharts([this.topChart, this.bottomChart])
    },
    cacheUsable(type) {
      return this.dataSet[type] && this.dataSet[type].t.length > 0
    },
    tabMutated(val) {
      if (this.klineType === val) return
      this.$nextTick(() => {
        this.topChart.resize()
        this.bottomChart.resize()
      })
      this.showTip = false
      const useCache = this.cacheUsable(val)
      // !useCache && this.initDataSet(val)
      this.klineDataInit = useCache
      this.klineType = val
      if (useCache) {
        this.isLikeMin1 ? this.renderMIN1Chart() : this.renderCandleChart()
      } else {
        this.initDataSet(val)
        this.initData()
      }
    },
    indicatorMutated(val) {
      // BOLL is belongs to top chart
      let renderCandle = this.techType === 'BOLL' || val === 'BOLL'
      this.techType = val
      renderCandle && this.renderCandleChart()
      this.renderBottomChart()
    },
    handleTip({ peer = 'topChart', show, x, y, isMoving }) {
      // throttle is useable
      // console.log(x && x.toFixed(1), y && y.toFixed(1))
      show && this[peer].dispatchAction({ type: `showTip`, x, y })
      !this.isLikeMin1 && !isMoving && this[peer].setOption({
        dataZoom: {
          disabled: show
        }
      })
    },
    forbiddenScroll(e) {
      e.preventDefault()
    },
    touchStart(e, peer) {
      this.showTip = false
      this.removeIfTimer()
      this.timer = setTimeout(() => {
        this.showTip = true
        this.handleTip({ show: true, peer, x: e.zrX, y: e.zrY })
      }, 300)
    },
    touchMove(e, peer) {
      if (!this.showTip) return this.touchEnd()
      this.handleTip({ show: true, peer, x: e.zrX, y: e.zrY, isMoving: true })
    },
    touchEnd() {
      this.removeIfTimer()
      this.timer = this.showTip ? setTimeout(() => {
        this.showTip = false
      }, 5000) : null
    },
    removeIfTimer() {
      this.timer && clearTimeout(this.timer)
    }
  }
}
</script>

<style lang="stylus" scoped>
.chart-wrapper
  margin-top .06rem
  height 3.65rem
  position relative

.top-title
  position absolute
  top 0
  z-index 11
  height .39rem
  background-color #FAFAFA
  width 100%

.sub-title
  height .14rem

.bottom-title
  position absolute
  right 0

.chart-section
  display flex
  height 3.25rem
  background-color white
  padding 0 .05rem
  .left
    margin .05rem 0
    width 2.6rem
    border 1px solid #f5f5f5
    position relative
    .icon
      height .17rem
      width .8rem
      position absolute
      left .9rem
  .left-full
    width 3.65rem
    .icon
      top 0.1rem
      left 1.42rem !important
  .right
    width 1.05rem

.main-chart-top {
  width 100%
  height: 2.55rem
}
.main-chart-bottom {
  width 100%
  height: .55rem
}
.top-full
  height: 2.14rem
.bottom-full
  height .68rem
.indicators
  height: .24rem
</style>